<template>
    <div>
        <h1 class="pt-2 text-sm">
            {{$t('form.tchat.reparation_en_autonomie')}}
        </h1>
        <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
            <template v-for="message in messages">
                <div :key="message.id">
                    <template v-if="message.show || message.typing">
                        <other-message v-if="sendByBot(message.type)">
                            <div v-if="message.typing" class="typing-loader"></div>
                            <span v-if="!message.typing" v-html="message.message"></span>
                        </other-message>
                        <my-message
                        v-if="message.type == 2 || message.type == 4"
                        @click="!message.disabled ? callbackResponse(message) : null"
                        :test-id="'my-message-' + message.groupIndex + '-' + message.index"
                        >
                            <span v-html="message.message"></span>
                        </my-message>
                        
                        <!-- Specific messages -->
                        <file-message
                        v-if="message.type == 5"
                        @click="!message.disabled ? callbackResponse(message) : null"
                        :default-data="message.data"
                        @save-file="(data) => {saveImage(message, data)}"
                        />
                    </template>
                </div>
            </template>
            <div v-if="(messages && messages.filter((msg) => msg.show == 1).length > 3) && $parent.blocks[$parent.blocks.length - 1].key != 'end-form'" @click="resetTchat" class="p-4 mt-4 font-light text-center duration-200 bg-gray-200 cursor-pointer opacity-70 hover:opacity-100 hover:bg-gray-300 rounded-xl">
                <i class="mr-1 fas fa-redo hover:opacity-100"></i> {{$t('form.tchat.recommencer_le_tchat')}}
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

import MyMessage from './Components/MyMessageBubble.vue'
import OtherMessage from './Components/BotMessageBubble.vue'
import FileMessage from './Components/FileMessageBubble.vue'

export default {
    name: 'own-tchat',
    extends: FormCardExtension,

    components: {
        MyMessage,
        OtherMessage,
        FileMessage
    },

    watch: {
        messages: function(valure) {
            window.clearTimeout(this.timerBotWriting)
            this.timerBotWriting = setTimeout(() => {
                this.botTyping()
            }, 300)
        }
    },

    data() {
        return {
            messages: [],
            request: null,
            botDelay: 1500,
            lastResponse: null,
            responseStep: 0,
            groupIndex: 0,
            groupResponseIndex: 0,
            timeWriting: 1000,

            timerBotWriting: null
        }
    },

    methods: {
        init() {
            /*
            TYPES:
                1: bot
                2: response
                3: solution
                4: solution reponse
                5: send file message
            */

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                let selectedData = this.$formTool.getFormData(this.$options.name)
                this.messages = selectedData.messages
                // this.messages.forEach((message, index) => {
                //     this.messages[index].delay = 0
                // })
                this.nextBlock = selectedData.next
                this.selected = JSON.parse(JSON.stringify(selectedData))
            } else {
                this.initTchat()
            }
        },

        end(callbackData) {
            let callback = {
                next: callbackData.next,
                messages: this.messages
            }
            this.$formTool.addFormData(this.$options.name, callback)
            this.nextBlock = callbackData.next
            this.selected = JSON.parse(JSON.stringify(callback))
        },

        /* =========================
            INIT TCHAT
        ========================= */

        async initTchat() {
            this.messages = []   
            this.request = null
            this.groupIndex = 0      
            // Init first messages
            this.addBotMessage(this.$t('form.tchat.bienvenue_sur_notre_assistance'), 1)
            this.addBotMessage(this.$t('form.tchat.ensemble_nous_allons_identifier_votre_panne'), 1)

            // Get request
            await this.sendRequestAndSetMessages()
        },

        resetTchat() {
            if (this.$formTool.getFormData('set-case')) {
                return
            }
            this.initTchat()
            if (localStorage['form-data']) {
                this.$formTool.removeFormData(this.$options.name);
                this.$emit('update', this.$options.name)
            }
        },

        makeId() {
            let result = ''
            let length = 20
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            let charactersLength = characters.length

            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength))
            }
            return result;
        },

        /* =========================
            GET DATA
        ========================= */

        async sendRequestAndSetMessages(responseId = null) {
            /*-----------------
                Build request
            -----------------*/
            const formData = {
                id_bdc: this.$formTool.getFormData('bdc2').post[0].id,
                id_question: this.request && this.request.question && this.request.question.length > 0 ? this.request.question[0].id : null,
            }
            if (responseId) {
                formData.id_rep = responseId
            }
            const response = await apiService.post('getquizz', formData)
            this.request = response.data.posts.post

            /*-----------------
                Set messages
            -----------------*/
            // Add questions
            this.request.question.forEach((question) => {
                this.addBotMessage(question.libelle, 1)
                this.groupIndex++
            })
            // Add response
            if (this.request.question.length <= 0) {
                if (this.request.solution) {
                    this.addBotMessage(this.request.solution.texte, 3)
                    if (this.request.solution && this.request.solution.quizz_photo == '1') {
                        this.addResponse(this.request.solution.texte, null, 5)
                    } else {
                        this.addBotMessage(this.$t('form.tchat.cette_solution_vous_a_t_elle_aide'), 3)
                        this.addResponse(this.$t('form.tchat.oui'), true, 4)
                        this.addResponse(this.$t('form.tchat.non'), false, 4)
                    }
                    this.groupIndex++
                    this.groupResponseIndex++
                }
                
            } else {
                this.groupIndex++
                // this.addResponse('Envoyer une photo de votre produit', null, 5)
                this.request.reponses.forEach((response) => {
                    this.addResponse(response.libelle, response, 2)
                })
                this.groupResponseIndex++
            }

            // No solutions
            if (this.request.question.length <= 0 && this.request.reponses.length <= 0 && !this.request.solution) {
                this.continueForm()
            }
        },

        /* =========================
            BOT MESSAGES
        ========================= */

        addBotMessage(message, type) {
            this.messages.push({
                type: type,
                show: false,
                typing: false,
                message: message,
                id: this.makeId(),
                group: this.groupIndex
            })
        },

        botTyping() {
            const unwrittenMessages = this.messages.filter((message) => this.sendByBot(message.type) && message.show == false && message.typing == false)

            if (unwrittenMessages && unwrittenMessages.length > 0) {
                window.scrollTo(0, document.body.scrollHeight - 100);
                unwrittenMessages[0].show = true
                unwrittenMessages[0].typing = true
                setTimeout(() => {
                    unwrittenMessages[0].typing = false
                    this.botTyping()
                }, this.timeWriting)
            } else {
                this.messages.filter((msg) => !this.sendByBot(msg.type)).map((msg) => {msg.show = true; return msg})
            }
        },

        sendByBot(type) {
            const botTypes = [1, 3]
            return botTypes.includes(type) ? true : false
        },

        /* =========================
            SPECIFIC MESSAGES
        ========================= */

        saveImage(message, data) {
            message.data = data
            this.$formTool.addFormData('quizz_image', data)
        },

        /* =========================
            USER MESSAGES
        ========================= */

        addResponse(message, data, type) {
            this.messages.push({
                type: type,
                message: message,
                data: data,
                id: this.makeId(),
                group: this.groupIndex,
                disabled: false,
                index: this.messages.filter((msg) => msg.group == this.groupIndex && !this.sendByBot(msg.type)).length,
                groupIndex: this.groupResponseIndex
            })
            setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight - 100);
            }, 100)
        },

        async callbackResponse(message) {
            message.disabled = true
            this.messages = this.messages.filter((msg) => msg.disabled || this.sendByBot(msg.type))

            if (message.type == 4) {
                // Anwser response
                if (message.data == true) {
                    // Solution has found
                    let response = await apiService.post('quizz_valid', {
                        id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                        id_app: this.$formTool.getFormData('device')[0].value.id
                    })

                    if (response.data.posts.post != 1) {
                        this.$toast.error('Une erreur est survenue')
                        return
                    }

                    this.addBotMessage(this.$t('form.tchat.nous_sommes_ravies_que_vous_ailliez_trouve_une_solution_a_bientot'), 1)

                    setTimeout(() => {
                        this.end({next: 'end-form'})
                    }, this.timeWriting + 500)
                } else {
                    // Solution not found
                    if (this.request.question.length > 0) {
                        // If new question, display question and answers
                        this.request.question.forEach((question) => {
                            this.addBotMessage(question.libelle, 1)
                            this.groupIndex++
                        })
                        this.groupIndex++
                        this.request.reponses.forEach((response) => {
                            this.addResponse(response.libelle, response, 2)
                        })
                    } else {
                        // Continue form
                        this.continueForm()
                    }
                }
            } else {
                // Get new question
                await this.sendRequestAndSetMessages(message.data.id)
            }            
        },

        /* =========================
            END FORM
        ========================= */

        continueForm() {
            this.addBotMessage(this.$t('form.tchat.aucune_solution_n_a_ete_trouve_merci_de_continuer_le_formulaire'), 1)
            setTimeout(async () => {
                // Online
                let response = await apiService.post('buyonline', {
                    id_app: this.$formTool.getFormData('device')[0].value.id
                })
                if (response.data.posts.post == 1) {
                    this.end({next: this.$formTool.blockData(this.$options.name).next.buyOnline})
                } else {
                    this.end({next: this.$formTool.blockData(this.$options.name).next.sign})
                }
            }, this.timeWriting + 500)
        }
    },

    mounted() {
        this.init()
    }
}
</script>

<style lang="scss">
.typing-loader {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    animation: loading 1s linear infinite alternate;
}

@keyframes loading {
 0% {
  background-color: rgba(000, 000, 000, 1);
  box-shadow: 
		12px 0px 0px 0px rgba(000, 000, 000, 0.2), 
		24px 0px 0px 0px rgba(000, 000, 000, 0.2);
 }
 25% {
  background-color: rgba(000, 000, 000, 0.4);
  box-shadow: 
		12px 0px 0px 0px rgba(000, 000, 000, 2), 
		24px 0px 0px 0px rgba(000, 000, 000, 0.2);
 }
 75% {
  background-color: rgba(000, 000, 000, 0.4);
  box-shadow: 
		12px 0px 0px 0px rgba(000, 000, 000, 0.2), 
		24px 0px 0px 0px rgba(000, 000, 000, 1);
 }
}
</style>



// WEBPACK FOOTER //
// src/processes/cards/tchat/OwnTchatCard.vue